// extracted by mini-css-extract-plugin
export default {"date-period-field":"_-web-client-js-react-components-dates-___DatePeriodField-module__date-period-field___o4M6M"};